// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"d8e09564","48":"198d8c26","557":"d61fe0b9","993":"198d8c26"}[chunkId] + ".chunk.css";
};